import { DxContainer, DxSpacer } from '@dvag/design-system-react';

import { KssAddressEdit } from './KssAddressEdit';
import { navigatePrevious } from '@dvag/dfs-orchestrator-client/messengers';

export const AddressEdit = () => {
  const onBack = () => {
    navigatePrevious();
  };
  const onClose = () => {
    navigatePrevious();
  };

  return (
    <DxContainer type="page" color="transparent" data-testid="address-edit">
      <DxSpacer size="32v" />
      <div style={{ margin: '0 32px' }}>
        <KssAddressEdit onBack={onBack} onClose={onClose} />
      </div>

      <DxSpacer size="32v" />
    </DxContainer>
  );
};
